// extracted by mini-css-extract-plugin
module.exports = {"sectionReaervationJtails":"ReservationSectionReservation-Jtails_sectionReaervationJtails_3i0Gq","isStyleDingBeauty":"ReservationSectionReservation-Jtails_isStyleDingBeauty_kkuhH"};